export default function getImageUniqueKey(packageUniqueKey, index) {
  return `${packageUniqueKey}-image-${index}`;
}
